import React from 'react'
import { Link } from 'react-router-dom'
import  ShowPosts  from './ShowPosts'
// import { client } from '../client'
import { urlFor } from '../client'

const AllPosts = ({posts}) => {
  return (
    <div className="bg-blue-200 min-h-screen p-12">
        <div className="container mx-auto">
        {/* <h2 className="text-5xl flex justify-center cursive">Blog Posts</h2> */}
            {/* <h3 className="text-lg text-gray-600 flex justify-center mb-12 mt-2">
                Welcome to Knowladge Hub!
            </h3> */}

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {posts?.map((post) => (
            <ShowPosts post = {post} key = {post._id} />
          ))}
      </div>
    </div>
  </div>
  )
}

export default AllPosts